var render = function render(){var _vm=this,_c=_vm._self._c;return _c('print-template',{attrs:{"viewFooter":false,"viewHeader":false}},[_c('svg',{attrs:{"id":'PART_ID_' + _vm.part.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }